import { axiosInstance } from ".."

const orderSummary = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/orderv2/summary/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default orderSummary;